import { forwardRef, type Ref, type SVGProps } from "react";
const IconMessageFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M27 4H5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h3v6a1 1 0 0 0 .08.38 1 1 0 0 0 .54.54.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21l6.7-6.71H27a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3" />
  </svg>
);
const ForwardRef = forwardRef(IconMessageFilledSVG);
ForwardRef.displayName = "IconMessageFilled";
export { ForwardRef as IconMessageFilled };
